import { render, staticRenderFns } from "./MarketReportLayout.vue?vue&type=template&id=27d43121"
import script from "./MarketReportLayout.vue?vue&type=script&lang=js"
export * from "./MarketReportLayout.vue?vue&type=script&lang=js"
import style0 from "./MarketReportLayout.vue?vue&type=style&index=0&id=27d43121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports